/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable react/prop-types */
import React from 'react';
import get from 'lodash/get';
import isArray from 'lodash/isArray';
import isEmpty from 'lodash/isEmpty';
import cx from 'classnames';
import Box from '@material-ui/core/Box';
import Button from 'components/Button';
import FileNameDisplay from 'components/FileNameDisplay';
import { openFileFromData } from 'util/file';
import DeleteIcon from 'assets/icons/trash.svg';

import { openFileURL } from './util';

import BaseFile from './components/File';

import classes from './UploadFile.module.scss';

const UploadFile = (props) => {
  const { inputProps, showPreview, hideErrAfter3s, fileListClassName, uploadDocument, viewImage, viewDocument } = props;
  const {
    formProps = {},
    name,
    onRemove,
    isCallApi = false,
    isSingleFile = true,
    isMultipleSelected = false,
    showUploadFiles = true,
    canRemoveFiles = true,
    onChange,
    notOpenToViewFile,
    disabled = false,
    maxFile = 0,
    originName,
    originSubName,
    alwaysShowBtn,
    ...other
  } = inputProps;
  const { errors, touched, values, setFieldValue } = formProps;
  const uploadFiles = get(values, name) || [];

  const handleFileUploaded = (file) => {
    const reader = new FileReader();
    reader.onloadend = () => {
      openFileFromData(reader.result);
    };
    reader.readAsDataURL(file);
  };

  return (
    <>
      <BaseFile
        alwaysShowBtn={alwaysShowBtn}
        hideErrAfter3s={hideErrAfter3s}
        uploadDocument={uploadDocument}
        inputProps={{
          name,
          placeholder: 'Select File',
          value: uploadFiles,
          onChange: (value) => {
            let changedUploadFiles = isSingleFile
              ? [value]
              : [...uploadFiles, ...(isMultipleSelected ? value : [value])];
            if (maxFile > 0) {
              changedUploadFiles = changedUploadFiles.splice(0, maxFile);
            }
            if (setFieldValue) setFieldValue(name, changedUploadFiles);
            if (onChange) onChange(changedUploadFiles);
          },
          // currentFileName: uploadFile,
          errorText:
            (get(touched, name) || get(touched, 'originName.0.originSubName')) &&
            (get(errors, name) || get(errors, 'originName.0.originSubName')),
          onRemove,
          isCallApi,
          isMultipleSelected,
          disabled,
          ...other,
        }}
      />
      {showUploadFiles && isArray(uploadFiles) && !isEmpty(uploadFiles) && (
        <div
          className={cx(classes.fileList, {
            [classes.disabled]: disabled,
            [classes.showPreview]: showPreview,
            [classes.viewImage]: viewImage,
          }, fileListClassName)}>
          <ul>
            {uploadFiles.map((f, i) => {
              // const extension = f.name || f.fileName ? (f.name || f.fileName).split('.').pop() : '';
              return (
                <li key={i}>
                  <Box className={classes.wrapperPreview}>
                    {showPreview && (
                      <img
                        alt={`preview_${i}`}
                        width='214'
                        height='121'
                        src={f.url || window.URL.createObjectURL(f)}
                      />
                    )}
                    <FileItem
                      file={f}
                      showPreview={showPreview}
                      notOpenToViewFile={notOpenToViewFile}
                      handleFileUploaded={handleFileUploaded}
                      canRemoveFiles={canRemoveFiles}
                      onClickRemoveFile={() => {
                        if (disabled && !showPreview) return;
                        const newUploadFiles = [...uploadFiles];
                        newUploadFiles.splice(i, 1);

                        setFieldValue(name, newUploadFiles);
                        if (onRemove) onRemove(i, f);
                      }}
                      viewImage={viewImage}
                    />
                  </Box>
                </li>
              );
            })}
          </ul>
        </div>
      )}
    </>
  );
};

export const FileItem = ({
  file,
  showPreview = false,
  notOpenToViewFile = false,
  handleFileUploaded = () => {},
  canRemoveFiles = true,
  onClickRemoveFile = () => {},
  viewImage = false,
}) => {
  const fName = file.name || file.fileName || '';
  const fNameArr = fName.split('.');
  const fType = (fNameArr[fNameArr.length - 1] || '').toUpperCase();

  const longSize = file.size / 1024 / 1024;
  const intSize = parseInt(longSize, 10);
  const floatSize = parseFloat(longSize);
  const fSize = file.size ? `${intSize === floatSize ? intSize : floatSize.toFixed(2)}MB` : `0MB`;

  const fUrl = file.url;

  return (
    <div className={classes.fileItem}>
      {/* <Box style={{ width: 48, height: 62, margin: 6 }}> */}
      {/*  <FileIcon extension={extension} {...defaultStyles[extension]} /> */}
      {/* </Box> */}
      {!viewImage && (<div>
        <span>{fType}</span>
      </div>)}
      <Box
        className={cx(classes.containerInfo, {
          [classes.showPreview]: showPreview,
          [classes.viewImage]: viewImage,
        })}>
          {viewImage ? (<img src={fUrl} alt="uploaded-f" />) : (
            <>
              <span
                className={classes.fileName}
                onClick={() => {
                  if (fUrl) {
                    openFileURL(fUrl);
                  } else if (!notOpenToViewFile) {
                    handleFileUploaded(file);
                  }
                }}>
                <FileNameDisplay filename={fName} type='item' />
              </span>
              <span>{fSize}</span>
            </>
          )}
        
        {canRemoveFiles && (
          <span className={classes.deleteIcon}>
            <Button
              type='icon'
              buttonProps={{
                onClick: onClickRemoveFile,
              }}>
                {viewImage ? (<span className={classes.viewImageDeleteIcon}>-</span>) : (<img alt='Delete' src={DeleteIcon} />)}
              
            </Button>
          </span>
        )}
      </Box>
    </div>
  );
};

export default UploadFile;
